module.exports = __webpack_public_path__ + "img/stopwatch.8022bd77.svg";